import { render, staticRenderFns } from "./positionManagement.vue?vue&type=template&id=326d1915&scoped=true"
import script from "./positionManagement.vue?vue&type=script&lang=js"
export * from "./positionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d1915",
  null
  
)

export default component.exports